import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerAssignmentPublicApplicantList,
	formatWorkerAssignmentPublicDetail,
	formatWorkerAssignmentPublicExcelList,
	formatWorkerAssignmentPublicList,
} from './worker-assignment-public.helper';
import { WorkerAssignmentPublicActions } from './worker-assignment-public.redux';
import {
	IPayloadDeleteWorkerAssignmentPublicRequest,
	IPayloadGetWorkerAssignmentPublicApplicantListRequest,
	IPayloadGetWorkerAssignmentPublicDetailRequest,
	IPayloadGetWorkerAssignmentPublicExcelListRequest,
	IPayloadGetWorkerAssignmentPublicListRequest,
} from './worker-assignment-public.type';

export function* getWorkerAssignmentPublicListSaga(
	action: PayloadAction<IPayloadGetWorkerAssignmentPublicListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerAssignmentFranchiseListResponse> =
			yield API.getWorkerAssignmentPublicList({ ...rest });

		const content = formatWorkerAssignmentPublicList(res?.data?.content);

		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicListFailure()
		);
	}
}

export function* getWorkerAssignmentPublicExcelListSaga(
	action: PayloadAction<IPayloadGetWorkerAssignmentPublicExcelListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerAssignmentFranchiseListResponse> =
			yield API.getWorkerAssignmentPublicList({ ...rest });

		const content = formatWorkerAssignmentPublicExcelList(res?.data?.content);

		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicExcelListSuccess()
		);
		callback?.({ data: content });
	} catch (error) {
		callback?.({ error });
		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicExcelListFailure()
		);
	}
}

export function* getWorkerAssignmentPublicDetailSaga(
	action: PayloadAction<IPayloadGetWorkerAssignmentPublicDetailRequest>
) {
	const { callback, id } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerAssignmentPublicDetailResponse> =
			yield API.getWorkerAssignmentPublicDetail(id);

		const detail = formatWorkerAssignmentPublicDetail(res?.data);

		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicDetailSuccess({
				detail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicDetailFailure()
		);
	}
}

export function* getWorkerAssignmentPublicApplicantListSaga(
	action: PayloadAction<IPayloadGetWorkerAssignmentPublicApplicantListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerAssignmentPublicApplicantListResponse> =
			yield API.getWorkerAssignmentPublicApplicantList({ ...rest });

		const content = formatWorkerAssignmentPublicApplicantList(
			res?.data?.content
		);

		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicApplicantListSuccess(
				{
					...rest,
					content,
					total: res?.data?.total,
				}
			)
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAssignmentPublicActions.getWorkerAssignmentPublicApplicantListFailure()
		);
	}
}

export function* deleteWorkerAssignmentPublicSaga(
	action: PayloadAction<IPayloadDeleteWorkerAssignmentPublicRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteWorkerAssignmentPublic(ids);

		yield put(
			WorkerAssignmentPublicActions.deleteWorkerAssignmentPublicSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAssignmentPublicActions.deleteWorkerAssignmentPublicFailure()
		);
	}
}
